<!--商品详情-->
<template>
  <div class="box">
    <div class="comment-box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="comment-li" v-for="(item, index) in list" :key="item.id">
            <div class="comment-li-user flex-start">
              <img :src="item.face" alt />
              <div class="comment-li-user-name">{{item.name}}</div>
            </div>
            <div class="comment-li-title">{{item.content}}</div>
            <div class="comment-li-pic flex-start">
              <div class="comment-li-pic-li" v-for="(pic, picIndex) in item.pics" :key="picIndex">
                <img :src="pic.url" alt />
              </div>
            </div>
            <div class="comment-li-star">
              <van-rate
                v-model="item.star"
                :size="25"
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"
                readonly
              />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!--    <div class="material-box">-->
    <!--      <img src="https://static.dierqudao.com/images/bg-btn-post.png" alt="" @click="toGoodsCommentAdd">-->
    <!--      <img src="https://static.dierqudao.com/images/bg-btn-mymaterail.png" alt="" @click="toGoodsCommentMyList">-->
    <!--    </div>-->
  </div>
</template>
<style scoped>
.comment-li {
  margin: 10px 15px 20px;
  border-bottom: 1px solid #eee;
}

.comment-li-user img {
  width: 30px;
  border-radius: 100%;
}

.comment-li-user-name {
  margin-left: 10px;
}

.comment-li-title {
  margin: 10px 0;
}
.comment-li-star {
  padding-bottom: 20px;
}

.comment-li-pic-li {
  width: 25%;
}

.comment-li-pic-li img {
  width: 90%;
  margin-right: 10%;
}

.comment-li-star {
  margin-top: 10px;
}

.material-box {
  height: 100px;
  width: 50px;
  position: fixed;
  top: 0;
  right: 15px;
  bottom: 0;
  margin: auto;
}

.material-box img {
  text-align: right;
  display: block;
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}
</style>

<script>
import Vue from "vue";

import {
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Toast
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Sku)
  .use(Toast);

export default {
  name: "GoodsComment",
  components: {},
  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      goodsId: 0,
      params: {
        goods_id: 0,
        p: 1,
        step: 10
      },
      list: []
    };
  },
  filter: {},
  activated() {},
  mounted() {
    document.title = "商品评价";
    let that = this;
    that.goodsId = that.params.goods_id = that.$route.query.id;
    that.getGoodsCommentList();
  },
  destroyed() {},
  methods: {
    getGoodsCommentList(ref) {
      let that = this;

      that.$api.get("/api/goods/materialList", that.params, res => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          if (ref) {
            that.$toast("刷新成功");
          }

          that.list = res.data.list;
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }
        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.p += 1;
      });
    },

    onLoad() {
      // console.log(1)
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getGoodsCommentList();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      that.getGoodsCommentList(1);
    },

    // 添加商品评价
    toGoodsCommentAdd() {
      let that = this,
        goodsId = that.goodsId;

      // console.log(goodsId)
      rbLink({
        name: "GoodsCommentOperate",
        query: {
          id: goodsId
        }
      });
       
    },

    toGoodsCommentMyList() {
      let that = this,
        goodsId = that.goodsId;
      rbLink({
        name: "GoodsMyComment",
        query: {
          id: goodsId
        }
      });
       
    }
  }
};
</script>



// WEBPACK FOOTER //
// GoodsComment.vue?144c88a6